import React, { Fragment } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Row, Table, Spinner } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';

import { api, createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import PaginationComponent from "../components/PaginationComponent";
import MyDateRenderer from "../components/MyDateRenderer";

import { useDispatch, useSelector } from "react-redux";
import * as emailActions from "../actions/EmailActions";
import * as documentActions from "../actions/DocumentActions";

const EmailSearchScreen  = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const loading = useSelector((state) => state.email.loading);
    const list = useSelector((state) => state.email.list);
    const filter = useSelector((state) => state.email.filter);
    const downloading = useSelector((state) => state.document.downloading);

    const doSearch = () => {
        var copy_filter = createDeepClone(filter);
        
        if(copy_filter.pageIndex == 1) {
            dispatch(emailActions.loadEmailSearch(filter, navigate));
        }
        else {
            copy_filter.pageIndex = 1;
            dispatch(emailActions.setEmailFilter(copy_filter));
        }
    }

    React.useEffect(() => {
		dispatch(emailActions.loadEmailSearch(filter, navigate));
    }, [filter.pageIndex]);

    const onFilterChange = (name, value) => {
        var copy_filter = createDeepClone(filter);
        copy_filter[name] = value;
        dispatch(emailActions.setEmailFilter(copy_filter));
    }
    
    const onPageChange = (page) => {
        var copy_filter = createDeepClone(filter);
        copy_filter.pageIndex = page;
        dispatch(emailActions.setEmailFilter(copy_filter));
    }

    const onDownloadServiceDocument = (id, documentName) => {
        dispatch(documentActions.downloadServiceDocument(id, documentName));
    };
    
    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Email Search" />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-3">
                                        <Col xxl={10} md={12}>
                                            <div className="search-box">
                                                <input type="text" className="form-control search" placeholder="Search for emails..."
                                                    value={filter.search}
                                                    onChange={e => onFilterChange("search", e.target.value)}
                                                />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </Col>
                                        {/* <Col xxl={2} md={12}>
                                            <select className="form-select"
                                                value={filter.active}
                                                onChange={e => onFilterChange("active", e.target.value)}
                                            >
                                                <option value={""}>All</option>
                                                <option value={true}>Unread</option>
                                                <option value={false}>Read</option>
                                            </select>
                                        </Col> */}
                                        <Col xxl={2} md={12}>
                                            <button type="button" className="btn btn-primary me-1 w-100" 
                                                disabled={loading || downloading}
                                                onClick= {() => doSearch()}
                                            >
                                                <i className="ri-search-eye-line"></i> Search
                                            </button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardLoader loading={loading || downloading} />
                                <CardBody>
                                    <div className="table-responsive table-card">
                                        <Table className="table-hover align-middle mb-0">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th>Email</th>
                                                    <th style={{width:200}}>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.dataList.map(function(item, index){
                                                    return(
                                                        <tr key={index}>
                                                            <td>
                                                                <div><strong>To:</strong> {item.to}</div>
                                                                <div><strong>Cc:</strong> {item.cc}</div>
                                                                <div><strong>Subject:</strong> {item.subject}</div>
                                                                <div>&nbsp;</div>
                                                                <div dangerouslySetInnerHTML={{__html: item.message}}></div>
                                                                {item.documentList.map((file, index) => {
                                                                    return (
                                                                        <Row className="gy-2 pt-5 font-14" key={index}>
                                                                            <Col xxl={6} md={6}>{file.description || file.name}</Col>
                                                                            <Col xxl={3} md={6}>
                                                                                <button type="button" className="btn btn-primary btn-sm me-1" title="Download Document"
                                                                                    onClick={() => onDownloadServiceDocument(file.id, file.name)}
                                                                                >
                                                                                    <i className="ri-download-line" /> Download
                                                                                </button>
                                                                            </Col>
                                                                        </Row>
                                                                    );
                                                                })}
                                                            </td>
                                                            <td style={{verticalAlign:"top"}}>
                                                                <div><MyDateRenderer value={item.dateAdded} /></div>
                                                                <div>{item.status}</div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <Row>
                                        <Col lg={12}>
                                            <PaginationComponent
                                                total={list.totalCount}
                                                currentPage={filter.pageIndex}
                                                onPageChange={page => onPageChange(page)}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default EmailSearchScreen;